import { UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import { UserCalendarType, UpdateUserCalendarRequest } from "../../types/userCalendars/type";
import userCalendarsAPI from "../../api/userCalendarsAPI";
import { userCalendarsQueryKeys } from "./queries";
import { debounceInvalidate } from "../../services/optimistic-updates/debounceInvalidate";
import { calendarQueryKeys } from "../calendar/queries";
import { inboxQueryKeys } from "../inbox/queries";

export const useUpdateUserCalendarMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<UserCalendarType, unknown, { id: number; data: UpdateUserCalendarRequest }>({
    mutationFn: ({ id, data }) => userCalendarsAPI.updateCalendar(id, data),
    onMutate: async (variables) => {
      await queryClient.cancelQueries({ queryKey: userCalendarsQueryKeys.all() });
      const previousData = queryClient.getQueryData<UserCalendarType[]>(
        userCalendarsQueryKeys.all()
      );
      if (previousData) {
        const updatedData = previousData.map((calendar) =>
          calendar.id === variables.id ? { ...calendar, ...variables.data } : calendar
        );
        queryClient.setQueryData(userCalendarsQueryKeys.all(), updatedData);
      }
      return { previousData };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userCalendarsQueryKeys.all() });
      debounceInvalidate.enqueueInvalidate(calendarQueryKeys.all, {
        delay: 1000,
      });
      debounceInvalidate.enqueueInvalidate(inboxQueryKeys.all(), {
        delay: 1000,
      });
    },
  });
};
